import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.WinterShoulder,
  voices: {
    main: {
      description:
        "haunted low tenor, stoic covert-ops restraint, cold breath and metal fatigue, Eastern European-flavored edges, suppressed comms microphone grit",
      seed: 10865,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I'm not anyone's sidekick. What I do is best done alone.",
      },
      { id: "select_2", text: "Winter Shoulder, reporting for duty." },
      { id: "select_3", text: "Winter Shoulder, awaiting orders." },
      { id: "select_4", text: "Winter Shoulder, on reserve." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "A war like this requires a rare kind of soldier…",
      },
      {
        id: "spawn_2",
        text: "Up to us to finish the mission, Frank. No holding back.",
      },
      {
        id: "spawn_3",
        text: "Nice to know I haven't lost my hunter's instinct after all these years…",
      },
      {
        id: "spawn_4",
        text: "Good to have a partner to hunt with for once, Elsa. You ready?",
      },
      {
        id: "spawn_5",
        text: "And here I thought the Second World War was a nightmare…",
      },
      {
        id: "spawn_6",
        text: "After what Hydra did to me, this fight got a lot more personal.",
      },
      {
        id: "spawn_7",
        text: "Time has claimed a lot of good soldiers. I won't let it take any more.",
      },
      {
        id: "spawn_8",
        text: "I'll do what's needed to win this, even if it does mean taking out former allies.",
      },
      {
        id: "spawn_9",
        text: "My past may be pretty cloudy, but if we don't win this, the future is pretty clear.",
      },
      {
        id: "spawn_10",
        text: "The battlefield may change, but the war never ends.",
      },
      {
        id: "spawn_11",
        text: "Sometimes I wish I could go back into the deep freeze for a few more decades.",
      },
      {
        id: "spawn_12",
        text: "I've done unspeakable things. I hope it's not too late to set them right.",
      },
      {
        id: "spawn_13",
        text: "I was rebuilt to be a weapon, but now I'm the one who pulls the trigger.",
      },
      {
        id: "spawn_14",
        text: "As long as there's still something worth fighting for, I'll be on the front lines.",
      },
      {
        id: "spawn_15",
        text: "I'm not a symbol like Steve. I'm just a soldier trying to do his job.",
      },
      {
        id: "spawn_16",
        text: "Weapons keep getting better, but it's still the person behind them that matters most.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I always come back." },
      { id: "respawn_2", text: "Been knocked down before. Doesn't last." },
      { id: "respawn_3", text: "My mission isn't over yet." },
      { id: "respawn_4", text: "You thought I was gone for good?" },
    ],
    ult_ally: [{ id: "ult_ally", text: "Stand down!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Armed and dangerous." }],
    secondary: [
      { id: "secondary_1", text: "Not so fast." },
      { id: "secondary_2", text: "Stick around." },
      { id: "secondary_3", text: "Come back here." },
    ],
    ability1: [
      { id: "ability1_1", text: "Playtime's over." },
      { id: "ability1_2", text: "You're up!" },
      { id: "ability1_3", text: "We're done here." },
    ],
    kill: [
      { id: "kill_1", text: "Target neutralized." },
      { id: "kill_2", text: "One down." },
      { id: "kill_3", text: "Got one." },
      { id: "kill_4", text: "Nothing personal." },
      { id: "kill_5", text: "Not today." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three in a row." },
      { id: "multikill_2", text: "Three down." },
      { id: "multikill_3", text: "Another one off my list." },
      { id: "multikill_4", text: "Five targets. Not too shabby." },
      { id: "multikill_5", text: "If this were a contest, I'd be winning." },
      { id: "multikill_6", text: "So… Ah, am I doing all the work here?" },
      { id: "multikill_7", text: "All clear." },
      { id: "multikill_8", text: "Mission accomplished." },
      { id: "multikill_9", text: "Who's next? No one? Good." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Feeling better now. Thanks." },
      { id: "low_hp_2", text: "Back in action." },
    ],
    healed: [
      { id: "healed_1", text: "Much better." },
      { id: "healed_2", text: "That's what I needed!" },
      { id: "healed_3", text: "This should help." },
      { id: "healed_4", text: "Needed one of these." },
    ],
  },
} satisfies VoiceScript;

export default script;
